/**
 * Used in web component properties for stringified complex types.
 */
export type Stringified<T> = string | T;
